export function gauge(ctx) {
    return {
        properties: {
            value_color: ctx.COLOR_BG_TEXT,
            value_font:  28,
            text_font:   28,
        },
        styles: {
            // GAUGE_PART_MAIN = `bg` + `gauge_main` (lv_theme_material.c:1393-1396).
            // border_color/border_width previously overrode `...ctx.pretty`'s correct
            // COLOR_BG_BORDER/2 (gauge_main never touches border) with ctx.primary/1 — a bug,
            // removed rather than restated. padding: 20 matches gauge_main's
            // pad_left/right/top (lv_theme_material.c:478-480, LV_DPX(20)) — was 10 (the
            // schema's own HASP-theme default). scale_end_line_width/scale_end_border_width
            // added: firmware values (LV_DPX(4)/LV_DPX(8), lv_theme_material.c:476-477) were
            // previously unset here, letting the schema's HASP-theme defaults (2/3) leak
            // through unmasked.
            main: {
                ...ctx.pretty,
                radius: 999,
                padding: 15,
                scale_width: 11,
                scale_border_width: 0,
                scale_end_line_width: 4,
                scale_end_border_width: 8,
                line_width: 4,
                line_color: '#888888',
                scale_grad_color: '#888888',
                scale_end_color: ctx.primary,
            },
            // GAUGE_PART_NEEDLE = `gauge_needle` (lv_theme_material.c:493-500). bg_color/
            // line_color are correctly white in the dark branch (LV_COLOR_WHITE,
            // lv_theme_material.c:494,497). line_width: 8 matches firmware (LV_DPX(8)) — was
            // 4, overriding the schema's own already-correct Phase 1 default (8).
            // border_color/border_width: firmware sets neither for gauge_needle (no border
            // drawn regardless, since border_width stays the schema default 0) — left as-is,
            // inert.
            indicator: {
                bg_color: '#ffffff',
                radius: 999,
                border_width: 0,
                line_color: '#ffffff',
                line_width: 5,
                line_rounded: true,
                border_color: ctx.primary,
            },
            // GAUGE_PART_MAJOR = `gauge_strong` (lv_theme_material.c:485-491). line_color/
            // scale_grad_color are fixed #888888 literals in firmware for BOTH light and dark
            // (lv_color_hex3(0x888), no IS_LIGHT ternary) — NOT theme.color_primary and NOT
            // white; both were wrong (left over from an interrupted prior edit that
            // incorrectly set them to white/primary). line_width: 8 matches firmware
            // (LV_DPX(8)) — was 4. scale_width: 25 matches firmware (LV_DPX(25)) — was 15.
            major_ticks: {
                line_width: 5,
                scale_width: 18,
                line_color: '#888888',
                scale_grad_color: '#888888',
                scale_end_color: ctx.primary,
            },
        },
    };
}
